import React from "react";
import { Badge } from "react-bootstrap";

const CustomBadge = ({ classes, text, color }) => {
  const badgeStyle = {
    backgroundColor: color || "#0AA7FF",
    fontSize: "14px",
    fontWeight: "bold",
    color: "#000",
  };

  return (
    <Badge className={`${classes} p-2`} bg="" pill style={badgeStyle}>
      {text}
    </Badge>
  );
};

export default CustomBadge;
